import { ProductType } from '@headless-workspace/typings';

export const getVariantImageShapeClassName = (type: ProductType, squaredShade: boolean): string => {
    const isShadeType = type === ProductType.MULTI_SKU_SHADE_UNI || type === ProductType.MULTI_SKU_SHADE_DIFF;

    return isShadeType && squaredShade ? 'rounded-0.25' : 'rounded-infinity';
};

export const getVariantImageClassNames = (
    type: ProductType,
    squaredShade: boolean,
): {
    imageClassName: string;
    shapeClassName: string;
} => {
    const imageClassName = 'w-variantImage h-variantImage';
    const shapeClassName = getVariantImageShapeClassName(type, squaredShade);

    return {
        imageClassName,
        shapeClassName,
    };
};
